import { render, staticRenderFns } from "./GeneralStatistics.vue?vue&type=template&id=5a55de7c&scoped=true&"
import script from "./GeneralStatistics.vue?vue&type=script&lang=js&"
export * from "./GeneralStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStatistics.vue?vue&type=style&index=0&id=5a55de7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55de7c",
  null
  
)

export default component.exports